<template>
	<div class="skyCheckboxCard" :style="{ width: width }">
		<crm-filter-panel label-width="100px" :groups="groups" @search="filterChange">
		</crm-filter-panel>
		<el-checkbox-group class="skyCheckbox" v-model="checkbox" @change="handleChange" v-bind="$attrs">
			<el-checkbox
				v-for="(item, index) in list"
				:label="item[props.id]"
				:disabled="filterOptions ? item.disabled() : item[props.disabled] == 1"
				:key="index"
				border
			>
				<span v-show="!isProductList"> {{ item[props.fileName] }} </span>
				<div v-if="isProductList" class="is_product_list">
					<div class="is_product_list_img">
						<img v-if="item['thumbnails'] && item['thumbnails'].length" :src="item['thumbnails'][0][props.imgUrl]" :alt="item['thumbnails'][0]['alt']" />
					</div>
					<div class="is_product_list_info">
						<div class="is_product_list_tit" :title="item[props.fileName]">{{ item[props.fileName] }}</div>
						<div class="is_product_list_weight">排序：{{ item[props.weight] }}</div>
					</div>
				</div>
				<span class="preview" @click="openUrl(item[props.url],$event)"> 查看页面 </span>
			</el-checkbox>
		</el-checkbox-group>
		<el-pagination
			v-if="isProductList"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
	</div>
</template>
<script>
import crmFilterPanel from '@/components/crm/crm-filterPanel.vue';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import { mapGetters } from 'vuex';
import { isHave } from '@/utils/index.js';

export default {
	name: 'skyCheckboxCard',
	components: {crmFilterPanel},
	props: {
		value: {
			type: Array,
			default: () => []
		},
		options: {
			type: Array,
			default() {
				return [];
			}
		},
		length: {
			type: Number,
			default: 1
		},
		groups: {
			type: Object,
			default() {
				return {
					others: [
						{
							tagName: 'sky-input',
							placeholder: '请输入产品名称查询',
							prop: 'name',
							value: '',
							clearable: true,
						},
						{
							tagName: 'sky-select',
							placeholder: '上架状态',
							prop: 'online',
							value: '1',
							options: [
								{
									label: '未上架',
									value: '0',
								},
								{
									label: '已上架',
									value: '1',
								},
							],
						},
						{
							tagName: 'sky-select',
							placeholder: '发布状态',
							prop: 'deploy',
							value: '2',
							options: [
								{
									label: '未发布',
									value: '0',
								},
								{
									label: '发布中',
									value: '1',
								},
								{
									label: '已发布',
									value: '2',
								},
							],
						},
						{
							tagName: 'sky-select',
							placeholder: '按照排序顺序',
							prop: 'order',
							value: 0,
							options: [
								{
									label: '按照排序顺序',
									value: 0,
								},
								{
									label: '按照更新日期',
									value: 1,
								},
								{
									label: '仅看置顶',
									value: 2,
								},
							],
						},
					],
				}
			}
		},
		domain: {
			type: String,
			default: ''
		},
		isProductList: {
			// 是否是推广产品
			type: Boolean,
			default: false
		},
		width: {
			type: String,
			default: '100%'
		},
		props: {
			type: Object,
			default() {
				return {
					id: 'id',
					url: 'path',
					fileName: 'fileName'
				};
			}
		},
		filterOptions: {
			type: Function,
			default: null
		}
	},
	watch: {
		options: {
			handler(val) {
				if (val) {
					this.list = val;
				}
			},
			immediate: true
		},
		value: {
			handler(val) {
				if (val && val.length) {
					this.checkbox = this.value.map(item => item[this.props.id]);
				}else {
					this.checkbox = [];
				}
			},
			immediate: true,
			deep: true,
		}
	},
	computed: {
		...mapGetters(['activeWebsite']),
	},
	data() {
		return {
			checkbox: [],
			list: [],
			currentPage: 1,
			total: 0,
			pageSize: 20,
		};
	},
	methods: {
		handleChange(val) {
			// 单选时，清除多余的选项
			if(this.length == 1 && this.checkbox.length > 1) {
				this.checkbox.shift();
			}
			let data = this.list.filter(item => isHave(item[this.props.id], val));
			this.$emit('input', data);
			this.$emit('change', data);
		},
		filterChange(val) {
			this.getDataList(val);
		},
		async getDataList(val={}) {
			if(this.isProductList) {
				let params = {
					...val,
					siteid: sessionStorage.getItem('projectId'),
					displayLength: this.pageSize,
					displayStart: this.currentPage
				};
				let res = await adsNewOnline.productList(params);
				this.list = res.data.data;
				// this.currentPage = res.data.page.currentPage;
				this.total = res.data.page.totalRecords;
			}else {
				let res = await adsNewOnline.classifyList({ siteid: sessionStorage.getItem('projectId') });
				this.list = res.data;
			}
		},
		handleSizeChange(val) {
			this.currentPage = 1;
			this.pageSize = val;
			this.getDataList({
				order: this.groups['others'][3].value,
				deploy: this.groups['others'][2].value,
				online: this.groups['others'][1].value,
				name: this.groups['others'][0].value,
			})
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getDataList({
				order: this.groups['others'][3].value,
				deploy: this.groups['others'][2].value,
				online: this.groups['others'][1].value,
				name: this.groups['others'][0].value,
			})
		},
		// 跳转链接打开新窗口
    openUrl(http, e) {
			e.preventDefault();
			e.stopPropagation();
			let url = 'https://' + this.domain + http;
      window.open(url, '_blank');
    },
	},
	mounted() {
		this.getDataList({
			order: 0,
			deploy: '2',
			online: '1'
		});
	},
};
</script>
<style lang="scss" scoped>
.skyCheckboxCard {
	.el-checkbox-group {
		display: flex;
    flex-wrap: wrap;
		justify-content: flex-start;
	}
	.skyCheckbox {
		margin: 5px 0;
		max-height: 400px;
		overflow-y: scroll;
	}
	.el-checkbox {
		height: auto;
		width: 200px;
    white-space: break-spaces;
		margin-left: 0px !important;
		margin-right: 5.5% !important;
		margin-bottom: 20px !important;
		display: flex;
    flex-direction: column;
		padding: 9px 20px 20px 10px;
		width: 29%;
	}
	.el-checkbox-group.skyCheckbox .el-checkbox:nth-child(3n) {
		margin-right: 0px !important;
	}
	.el-checkbox:last-of-type {
    margin-right: 30px;
	}
	.preview {
		position: absolute;
		right: 0;
		bottom: 0;
		color: #409eff;
		cursor: pointer;
		z-index: 2;
	}
	.is_product_list {
		display: flex;
		.is_product_list_img {
			width: 70px;
			height: 70px;
			img {
				width: 70px;
				height: 70px;
				border-radius: 2px;
			}
		}
		.is_product_list_info {
			flex: 1;
			padding-left: 5px;
			.is_product_list_tit {
				display:-webkit-box;
				-webkit-box-orient:vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
		}
	}
}
</style>
